/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 일정 추가 모달 헤더
 * 버전 : 1.0
 * 파일명 : ModalTitleAddSchedule.tsx
 * 작성자 : 강동형
 * 작성일 : 2025-03-01
 * 수정 : 2025-07-07, 강동형 : 저작권 추가, 버튼 비활성화 로직 추가
 * ================================================================ */

import { Divider } from '@mui/material'
import styled from 'styled-components'
import { ActionButton, NextButton } from '../common/CommonStyled'
import { ModalAdSheduleAddStore, useModalStore } from 'src/stores/ModalStore'
import { postArmyRecruit } from 'src/api/Admin'
import { useFetchRecruitSchedule } from './useLoadRecruitSchedule'

const PageWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;

    position: relative;
    font-size: 32px;
    font-weight: 700;
    margin-bottom: 20px;
`
const ButtonWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;

    height: 54px;
    position: absolute;
    right: 0;
`
const ModalTitleAddSchedule = () => {
  const title = ModalAdSheduleAddStore((state)=>state.title)
  const type = ModalAdSheduleAddStore((state)=>state.type)
  const certification = ModalAdSheduleAddStore((state)=>state.certification)
  const urlLink = ModalAdSheduleAddStore((state)=>state.urlLink)
  const recruitestartdate = ModalAdSheduleAddStore((state)=>state.recruitestartdate)
  const recruiteenddate = ModalAdSheduleAddStore((state)=>state.recruiteenddate)
  const startjob = ModalAdSheduleAddStore((state)=>state.startjob)
  const endjob = ModalAdSheduleAddStore((state)=>state.endjob)
  const etc = ModalAdSheduleAddStore((state)=>state.etc)
  const setField = useModalStore((state)=>state.setField)
  const { fetchData } = useFetchRecruitSchedule();

  const isValid = !!(title && recruitestartdate && recruiteenddate && startjob && endjob);

  const onclickPost = async()=>{
    await postArmyRecruit(
      { title : title,
        recruitment_type : type,
        requirements : certification,
        source_url : urlLink,
        application_sdate : recruitestartdate,
        application_edate : recruiteenddate,
        enlistment_date : startjob,
        appointment_date : endjob,
        etc :etc
      })
    fetchData()
    setField('open',false)
  }

  return (
    <>
    <PageWrapper>
        모집 일정 등록
        <ButtonWrapper>
            <ActionButton style={{width:'94px', height: '54px'}} onClick={()=>setField('open',false)}>취소</ActionButton>
            <NextButton style={{width:'94px', height:'100%'}} onClick={onclickPost} disabled={!isValid}>등록</NextButton>
        </ButtonWrapper>
    </PageWrapper>
    <Divider sx={{width:'100%', borderColor:'#D1D1D1'}}/>
    </>
  )
}

export default ModalTitleAddSchedule